'use strict';

import $ from 'jquery';

let config = {
    static: true,
    onReady() {
        $(window).on('flatpickr:clear', $.proxy(function () {
            this.clear();
        }, this));
    },
    prevArrow: `<svg class="flatpickr__arrow"><use xlink:href="#icon-arrow-left"></use></svg>`,
    nextArrow: `<svg class="flatpickr__arrow"><use xlink:href="#icon-arrow-right"></use></svg>`,
};

export default config;



// WEBPACK FOOTER //
// ./app/general/js/base-datepicker-config.js